import { defineComponent as d, ref as r, onMounted as f, watch as v, openBlock as g, createElementBlock as h, renderSlot as m } from "vue";
const u = (() => {
  function p(e, n) {
    return new Promise((t) => {
      e == null && t(null);
      const l = e.scrollHeight, c = e.style.transition;
      e.style.transition = "", requestAnimationFrame(() => {
        e.style.height = `${l}px`, e.style.transition = c, requestAnimationFrame(() => {
          e.style.height = n ? `${n}px` : "0", t(null);
        });
      }), e.dataset.collapsed = "true";
    });
  }
  function a(e, n) {
    e.style.height = n ? `${n}px` : "0", e.dataset.collapsed = "true";
  }
  function o(e) {
    e.style.overflow = "hidden";
  }
  function s(e) {
    return new Promise((n) => {
      e == null && n(null);
      const t = e.scrollHeight;
      e.style.height = `${t}px`, e.addEventListener("transitionend", l);
      function l() {
        e.removeEventListener("transitionend", l), n(null);
      }
      e.dataset.collapsed = "false";
    });
  }
  function i(e) {
    e.dataset.collapsed === "false" && (e.style.overflow = "auto", e.style.height = "auto");
  }
  return {
    collapse: p,
    collapseWithoutAnimation: a,
    preCollapse: o,
    expand: s,
    postExpand: i
  };
})(), x = /* @__PURE__ */ d({
  __name: "CollapsibleComp",
  props: {
    toggle: { type: Boolean, default: !1 },
    previewHeight: { default: 0 }
  },
  setup(p) {
    const a = r(), o = p, s = r(o.toggle), i = (t = !0) => {
      let l = a;
      l && l.value && (u.preCollapse(l.value), t ? u.collapse(l.value, o.previewHeight) : u.collapseWithoutAnimation(l.value, o.previewHeight));
    }, e = () => {
      if (a && a.value) {
        let t = a.value;
        t && t.dataset && t.dataset.collapsed === "true" && u.expand(t).then(u.postExpand.bind(null, t));
      }
    }, n = (t = null) => {
      t !== null ? (s.value = t, t ? i() : e()) : (s.value = !s.value, s.value ? i() : e());
    };
    return f(() => {
      a && a.value && (o.toggle ? i(!1) : a.value.dataset.collapsed = "false");
    }), v(() => o.toggle, (t, l) => {
      n(t);
    }), (t, l) => (g(), h("div", {
      class: "collapsible",
      ref_key: "collapsibleRef",
      ref: a,
      "data-collapsed": "true",
      style: { transition: "0.5s all ease-in-out" }
    }, [
      m(t.$slots, "default")
    ], 512));
  }
});
export {
  x as CollapsibleComp
};
//# sourceMappingURL=CollapsibleComp.js.map
